"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addNewFilter = exports.getAddFilterOptions = exports.FilterTypeEnums = exports.getPathIndex = exports.filterData = exports.getBooleanOptionName = exports.getOperatorOptions = exports.getFields = void 0;
const core_1 = require("@apitable/core");
const immer_1 = __importDefault(require("immer"));
const getFields = (columns, fieldMap) => {
    return columns.map(column => {
        return fieldMap[column.fieldId];
    });
};
exports.getFields = getFields;
const getOperatorOptions = (field) => {
    const fOperators = core_1.Field.bindModel(field).acceptFilterOperators;
    // No support for "duplicate" operations.
    return fOperators.filter(fop => fop != core_1.FOperator.IsRepeat).map(fop => {
        return {
            value: fop,
            label: core_1.Field.bindModel(field).showFOperatorDesc(fop),
        };
    }).filter(Boolean);
};
exports.getOperatorOptions = getOperatorOptions;
const getBooleanOptionName = (value) => {
    if (value === 'and') {
        return (0, core_1.t)(core_1.Strings.robot_trigger_match_condition_and);
    }
    if (value === 'or') {
        return (0, core_1.t)(core_1.Strings.robot_trigger_match_condition_or);
    }
    return '';
};
exports.getBooleanOptionName = getBooleanOptionName;
exports.filterData = {
    filter: {
        type: 'Literal',
        value: {
            operands: [
                {
                    type: 'Expression',
                    value: {
                        operands: [
                            {
                                type: 'Literal',
                                value: 'fldPCvePQTx0g'
                            },
                            {
                                type: 'Literal',
                                value: 'optCA1Qr7mn3X'
                            }
                        ],
                        operator: 'equal'
                    }
                },
                {
                    type: 'Expression',
                    value: {
                        operands: [
                            {
                                type: 'Literal',
                                value: 'fldiyZVA2QhFe'
                            },
                            {
                                type: 'Literal',
                                value: 3
                            }
                        ],
                        operator: 'greaterThan'
                    }
                },
                {
                    type: 'Expression',
                    value: {
                        operands: [
                            {
                                type: 'Expression',
                                value: {
                                    operands: [
                                        {
                                            type: 'Literal',
                                            value: 'fldPCvePQTx0g'
                                        },
                                        {
                                            type: 'Literal',
                                            value: 'optCA1Qr7mn3X'
                                        }
                                    ],
                                    operator: 'equal'
                                }
                            },
                            {
                                type: 'Expression',
                                value: {
                                    operands: [
                                        {
                                            type: 'Literal',
                                            value: 'fldiyZVA2QhFe'
                                        },
                                        {
                                            type: 'Literal',
                                            value: 3
                                        }
                                    ],
                                    operator: 'greaterThan'
                                }
                            }
                        ],
                        operator: 'or'
                    }
                }
            ],
            operator: 'and'
        }
    },
    datasheetId: {
        type: 'Literal',
        value: 'dst7CQK5vuco6J0uCZ'
    }
};
// Parse string path "operands[1]" => 1
const getPathIndex = (path) => {
    const index = path.replace(/\D/g, '');
    return index ? parseInt(index, 10) : 0;
};
exports.getPathIndex = getPathIndex;
var FilterTypeEnums;
(function (FilterTypeEnums) {
    FilterTypeEnums["Filter"] = "filter";
    FilterTypeEnums["FilterGroup"] = "filterGroup";
})(FilterTypeEnums = exports.FilterTypeEnums || (exports.FilterTypeEnums = {}));
const getAddFilterOptions = (depth) => {
    const addFilterOptions = [
        {
            value: FilterTypeEnums.Filter,
            label: 'Add filter conditions',
            subLabel: ''
        }
    ];
    // It's only a matter of time before the group filter is limited to a maximum of 3 levels.
    if (depth < 2) {
        addFilterOptions.push({
            value: FilterTypeEnums.FilterGroup,
            label: 'Add grouping filter conditions',
            subLabel: 'Grouping filter conditions can be nested and stacked, similar to raising the priority of operations through parentheses'
        });
    }
    return addFilterOptions;
};
exports.getAddFilterOptions = getAddFilterOptions;
const addNewFilter = (filter, type, primaryField) => {
    const getNewFilter = () => {
        const acceptFilterOperators = primaryField ? core_1.Field.bindModel(primaryField).acceptFilterOperators : [];
        const newFilter = {
            type: core_1.OperandTypeEnums.Expression,
            value: {
                operator: (acceptFilterOperators[0] || core_1.FOperator.IsNotEmpty),
                operands: [
                    { type: core_1.OperandTypeEnums.Literal, value: primaryField === null || primaryField === void 0 ? void 0 : primaryField.id },
                    { type: core_1.OperandTypeEnums.Literal, value: null }
                ]
            }
        };
        if (type === FilterTypeEnums.FilterGroup) {
            const newFilterExpression = {
                type: core_1.OperandTypeEnums.Expression,
                value: {
                    operator: (filter === null || filter === void 0 ? void 0 : filter.operator) || core_1.OperatorEnums.And,
                    operands: [
                        newFilter
                    ]
                }
            };
            return newFilterExpression;
        }
        return newFilter;
    };
    const newFilter = getNewFilter();
    if (filter) {
        return (0, immer_1.default)(filter, (draft) => {
            draft.operands.push(newFilter);
        });
    }
    // When the filter is created initially, it is always returned as a group.
    return {
        operator: core_1.OperatorEnums.And,
        operands: [
            newFilter
        ]
    };
};
exports.addNewFilter = addNewFilter;
